import { Key } from 'react';
import { DonorType } from '@/api/apis/case';
import { RSContractorAssignmentCandidate } from '@/api/apis/resources';
import { columns } from '../config';
import {
  Affiliation,
  ConflictReservationInfo,
  LocationCell,
  OrgansLastCall,
  ReserveButton,
  ResourceNameCell,
  ThirtyDays,
} from '../../components';
import { formatHomeLocation } from '../utils';

export const renderContractorSurgeonTableCell =
  (
    isLogistics: boolean,
    donorType: DonorType,
    onReserve: (csCandidate: RSContractorAssignmentCandidate) => void,
    caseName?: string,
  ) =>
  (surgeonData: RSContractorAssignmentCandidate & { isSelected?: boolean }, key: Key) => {
    const {
      isSelected,
      employeeFullName,
      employeeProfilePhoto,
      employeeCertificates,
      lastCallDays,
      lastTrackedLocation,
      match,
      conflictedReservation,
      homeLocation,
      days30Stats,
      affiliation,
    } = surgeonData;

    const handleReserve = () => {
      onReserve(surgeonData);
    };

    switch (key) {
      case columns.name.key:
        return <ResourceNameCell fullName={employeeFullName} photoPath={employeeProfilePhoto} />;
      case columns.organLastCall.key:
        return (
          <OrgansLastCall
            donorType={donorType}
            shiftCertificates={employeeCertificates} // no shift serts for contractors, so using employee
            employeeCertificates={employeeCertificates}
            lastCallDaysByOrgan={lastCallDays.forCaseDonorByOrgan}
          />
        );
      case columns.thirtyDays.key:
        return <ThirtyDays stats={days30Stats} />;
      case columns.location.key:
        return (
          <LocationCell locationName={formatHomeLocation(homeLocation)} lastTrackedLocation={lastTrackedLocation} />
        );
      case columns.affiliation.key:
        return <Affiliation affiliationData={affiliation} />;
      case columns.reservationCondition.key:
        return conflictedReservation ? (
          <ConflictReservationInfo
            reservation={conflictedReservation}
            caseTypeMatch={match.caseType}
            caseName={caseName}
          />
        ) : (
          'Free'
        );
      case columns.reserve.key:
        return (
          <ReserveButton
            onReserve={handleReserve}
            isSelected={isSelected}
            isLogistics={isLogistics}
            assignActionType={match.availableActionType}
          />
        );
      default:
        return null;
    }
  };
